import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { ReactComponent as Spinner } from "../assets/icons/spinner.svg";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import PayloftLogo from "../assets/images/payloft-logo.png";
import { useAuth } from "../context/AuthContextProvider";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [inputPassNew, setInputPassNew] = useState("password");
  const [showNew, setShowNew] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const navigate = useNavigate();
  const { login, loading } = useAuth();
  const env = localStorage.getItem("environment");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      if (email !== "" && password !== "") {
        await login(email, password);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleShowNew = (e) => {
    e.preventDefault();
    setShowNew(!showNew);
    setInputPassNew(inputPassNew === "password" ? "text" : "password");
  };

  // Load email and password from localStorage on component mount
  useEffect(() => {
    const storedEmail = localStorage.getItem("rememberedEmail");
    const storedPassword = localStorage.getItem("rememberedPassword");
    if (storedEmail && storedPassword) {
      setEmail(storedEmail);
      const decryptedPassword = decryptPassword(storedPassword);
      setPassword(decryptedPassword);
      setRememberMe(true);
    }
  }, []);

  // Save email and password to localStorage when "Remember Me" is checked
  useEffect(() => {
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", email);
      const encryptedPassword = encryptPassword(password);
      localStorage.setItem("rememberedPassword", encryptedPassword);
    } else {
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
    }
  }, [rememberMe, email, password]);

  const encryptPassword = (value) => {
    return CryptoJS.AES.encrypt(value, "secretkey123").toString();
  };

  const decryptPassword = (encryptedValue) => {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, "secretkey123");
    return bytes.toString(CryptoJS.enc.Utf8);
  };

  return (
    <div className="flex justify-center">
      <div className="sm:w-[375px] w-full justify-center  p-4">
        <div className="flex flex-col items-center justify-center">
          {env && (
            <span className="text-xs font-semibold text-orange-500 uppercase tracking-wide">
              {env} ENVIRONMENT
            </span>
          )}
          <img
            src={window.__TENANT__?.logo ?? PayloftLogo}
            alt="logo"
            className="w-[92px] h-auto"
          />
        </div>
        <h1 className="text-[25px] font-semibold border-b pb-14 text-center mt-10">
          Login
        </h1>
        <div className="flex flex-col mt-4">
          <form onSubmit={handleLogin}>
            <div className="flex flex-col ">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="focus:outline-none h-[50px] w-full xl:w-[348px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>
            <div className="flex flex-col mt-8 relative">
              <label htmlFor="password">Password</label>
              <button
                type="button"
                onClick={handleShowNew}
                className="absolute right-0 top-12"
                tabIndex={-1}
              >
                {showNew ? <FaEyeSlash /> : <FaEye />}
              </button>
              <input
                type={inputPassNew}
                id="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="focus:outline-none h-[50px] w-full xl:w-[348px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                required
              />
            </div>
            <div className="flex items-center justify-between mt-6">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <p className="text-sm">Remember me</p>
              </div>
              <div>
                <div
                  className="text-primary cursor-pointer text-sm"
                  onClick={() => navigate("/reset-password")}
                >
                  Reset Password?
                </div>
              </div>
            </div>
            <div className="mt-10">
              <button
                className="bg-primary w-full md:w-[348px] h-[50px] text-white rounded-md"
                type="submit"
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </div>
          </form>
        </div>
        <p className="text-center mt-4">
          New to Payloft?{" "}
          <span>
            <Link className="text-primary" to="/sign-up">
              Create New Account
            </Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
